import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-2xl bg-gradient-to-br from-white via-gray-100 to-white border border-gray-300 rounded-3xl shadow-xl p-10 md:p-14 space-y-10">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4 text-purple-600">Get in Touch</h2>
          <p className="text-gray-700 text-lg max-w-xl mx-auto">
            Got a question or an idea? We'd love to hear from you. Fill out the form below and we’ll respond as soon as possible.
          </p>
        </div>

        <form className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input
              type="text"
              id="name"
              className="w-full rounded-lg border border-purple-600 bg-white text-gray-900 placeholder-gray-400 py-3 px-4 focus:ring-2 focus:ring-purple-500 focus:outline-none transition"
              placeholder="Your name"
              required
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="w-full rounded-lg border border-purple-600 bg-white text-gray-900 placeholder-gray-400 py-3 px-4 focus:ring-2 focus:ring-purple-500 focus:outline-none transition"
              placeholder="you@example.com"
              required
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              Message
            </label>
            <textarea
              id="message"
              rows="5"
              className="w-full rounded-lg border border-purple-600 bg-white text-gray-900 placeholder-gray-400 py-3 px-4 focus:ring-2 focus:ring-purple-500 focus:outline-none transition"
              placeholder="Type your message here..."
              required
            ></textarea>
          </div>

          <div className="pt-2 text-center">
            <button
              type="submit"
              className="inline-block py-3 px-8 rounded-lg bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-purple-500/30 transition text-white font-semibold shadow-lg"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
